import React from 'react';
import { TaskItemAction } from '../../model';
import Button from '../Button';
import Modal from '../Modal';
import { CallViewByItemDetails } from './CallDetailsPanel';
import './ChatView.scss';
import './ChatViewPanel.scss';
import OutboundView from './OutboundView';

export interface ShowChatState {
  chatId: string
}

export default function OutBoundVieDialog({ id, onClose }: { id: string, onClose(): void }) {
  //using email id as media id as
  /*const chat = useSelector(s => getChatById(s, chatId))
  const dispatch = useDispatch()

  useEffect(() => {
    if (chatId === '') { return }
    dispatch(actions.fetchChatReadRequest(chatId))
  }, [dispatch, chatId])
*/
  function handleClose() {
    //should do this but need to check if it's active in agent view before doing it
    //dispatch(actions.removeMediaItem(chatId))

    onClose()
  }

  //if (!chat || !chatId) { return null }

  const customStyles = {
    content: {
      width: '50%',
      height: '70%',
    },
  };

  return <Modal style={customStyles} isOpen={true} className='EmailModal'>
    <CallViewByItemDetails itemId={id} itemType='TC' itemAction={TaskItemAction.none} onClose={handleClose} />
    <OutBoundViewPanel id={id} />
  </Modal>
}

export function OutBoundViewPanel({ id, onClose }: { id: string, onClose?(): void }) {


  return <div className='OutViewPanel'>
    <div className='title'>
      <h2>Outbound</h2>
      {onClose && <Button className='close' onClick={() => onClose()}>X</Button>}
    </div>
    <OutboundView mediaItemId={id} />
  </div>
}
